import { render, staticRenderFns } from "./BgImageSlides.vue?vue&type=template&id=39bd4190&scoped=true"
import script from "./BgImageSlides.vue?vue&type=script&lang=js"
export * from "./BgImageSlides.vue?vue&type=script&lang=js"
import style0 from "./BgImageSlides.vue?vue&type=style&index=0&id=39bd4190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd4190",
  null
  
)

export default component.exports